import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import qs from "query-string";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import config from "../../../config.js";
import auth from "../../../utils/authenticator";
import defaultClients from "../../../utils/clientsConfig.js";

import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
      Role: "",
      showClientSelector: false,
      availableClients: [],
      tempToken: null,
      tempUser: null,
      loadingClients: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loginauth = () => {
    auth.isAuthenticated(() => {
      if (this._isMounted) this.setState({ redirectToReferrer: true });
    });
  };
  addToken = (token, user) => {
    this.setState({
      token,
    });
    auth.authenticate(token, user);
  };

  usernameRef = React.createRef();
  passwordRef = React.createRef();

  Login = (e) => {
    e.preventDefault();
    let data = qs.stringify({
      email: this.usernameRef.current.value,
      password: this.passwordRef.current.value,
    });

    axios
      .post(`${config.DOMAIN}users/login`, data, { headers: config.headers })
      .then((res) => {
        // agregarlo y enviarlo state
        const data = jwtDecode(res.data.token);
        const validRoles = [
          "ADMIN_ROLE",
          "GESTION_ROLE",
          "TRANSLATE_ROLE",
          "COMMERCIAL_ROLE",
          "SEO_ROLE",
        ];

        if (!data || !data.user || !validRoles.includes(data.user.role)) {
          Swal.fire("No logeado", "Usuario de rol inválido", "error");
          return;
        }

        const allowedRolesMultipleClients = ["COMMERCIAL_ROLE", "GESTION_ROLE", "SEO_ROLE"];

        // Si es comercial o de gestión, verificar si tiene múltiples clientes
        if (allowedRolesMultipleClients.includes(data.user.role)) {
          this.setState({
            tempToken: res.data.token,
            tempUser: res.data.user,
            loadingClients: true
          });
          this.checkAvailableClients(res.data.token);
        } else {
          // Para otros roles, login normal
          this.addToken(res.data.token, res.data.user);
          this.loginauth();
          this.setState({ Role: data.user.role, redirectToReferrer: true });
        }

        // resetear datos
        //e.currentTarget.reset();
      })
      .catch((error) => {
        if (error?.response?.status === 404 || error?.response?.status === 400) {
          Swal.fire("No logeado", error.response.statusText, "error");
        }
      });
  };

  checkAvailableClients = (token) => {
    const headers = { ...config.headers, token: token };

    axios
      .get(`${config.DOMAIN}auth/available-clients`, { headers })
      .then(res => {
        const apiClients = res.data.data || [];
        const clients = defaultClients.filter(dc => apiClients.some(ac => ac.clientId === dc.clientId));
        if (clients.length > 1) {
          this.setState({
            showClientSelector: true,
            availableClients: clients,
            loadingClients: false
          });
        } else {
          // Solo un cliente, continuar login normal
          this.completeLogin(this.state.tempToken, this.state.tempUser);
        }
      })
      .catch(error => {
        console.error("Error fetching clients:", error);
        this.completeLogin(this.state.tempToken, this.state.tempUser);
      });
  };

  handleSelectClient = (client) => {
    this.setState({ loadingClients: true });

    const headers = { 
      ...config.headers, 
      token: this.state.tempToken,
      "Content-Type": "application/json"
    };

    axios
      .post(
        `${config.DOMAIN}auth/switch-client`,
        { clientId: client.clientId },
        { headers }
      )
      .then(res => {
        const { token, user } = res.data.data;
        this.completeLogin(token, user);
      })
      .catch(error => {
        this.setState({ loadingClients: false });
        Swal.fire("Error", "No se pudo cambiar al cliente seleccionado", "error");
      });
  };

  completeLogin = (token, user) => {
    this.addToken(token, user);
    this.loginauth();
    this.setState({
      Role: user.role,
      redirectToReferrer: true,
      showClientSelector: false
    });
  };

  render() {
    const { 
      redirectToReferrer, 
      Role, 
      showClientSelector, 
      availableClients, 
      loadingClients 
    } = this.state;

    if (redirectToReferrer) {
      if (Role === "COMMERCIAL_ROLE") {
        return <Redirect to="/orders" />;
      } else if (Role === "SEO_ROLE") {
        return <Redirect to="/dynamicpages" />;
      } else {
        return <Redirect to="/" />;
      }
    }

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.Login}>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Username"
                          autoComplete="username"
                          className="form-control"
                          innerRef={this.usernameRef}
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          autoComplete="current-password"
                          className="form-control"
                          innerRef={this.passwordRef}
                        />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button color="primary" className="px-4">
                            Login
                          </Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Button color="link" className="px-0">
                            Forgot password?
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>

        {/* Modal selector de clientes para comerciales */}
        <Modal isOpen={showClientSelector} centered>
          <ModalHeader>
            <i className="fa fa-building mr-2"></i>
            Selecciona el cliente
          </ModalHeader>
          <ModalBody>
            {loadingClients ? (
              <div className="text-center p-4">
                <i className="fa fa-spinner fa-spin fa-2x"></i>
                <p className="mt-2">Cargando clientes...</p>
              </div>
            ) : (
              <>
                <p className="text-muted mb-3">
                  Tienes acceso a múltiples clientes. Selecciona con cuál deseas trabajar:
                </p>
                <ListGroup>
                  {availableClients.map(client => (
                    <ListGroupItem
                      key={client.clientId}
                      action
                      onClick={() => this.handleSelectClient(client)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          {client.logo ? (
                            <img
                              src={client.logo}
                              alt=""
                              style={{ 
                                width: 32, 
                                height: 32, 
                                marginRight: 12, 
                                borderRadius: 4,
                                objectFit: "contain"
                              }}
                            />
                          ) : (
                            <i className="fa fa-building fa-2x mr-3 text-muted"></i>
                          )}
                          <div>
                            <strong>{client.name}</strong>
                            {client.domain && (
                              <small className="d-block text-muted">{client.domain}</small>
                            )}
                          </div>
                        </div>
                        <i className="fa fa-chevron-right text-muted"></i>
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Login;
